import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { injectable } from 'inversify';

// one way, one to one linking between ViewModels for visibility state
@injectable()
export class VisibilityLinkedVMController {
  private _linkedVMs: Map<string, string> = new Map();

  public add(origin: string, target: string): void {
    this._linkedVMs.set(origin, target);
  }

  public remove(origin: string): void {
    this._linkedVMs.delete(origin);
  }

  public setLinkedObjectVisibility(origin: string, currentView: ViewEntity | null, isVisible: boolean): void {
    const linkedObject = this._linkedVMs.get(origin);
    if (linkedObject) {
      currentView?.getObjectByDescriptor(linkedObject)?.setVisibility(isVisible);
    }
  }
}
